import React from 'react';
import { styled } from '@mui/system';
import { Button } from '@mui/material';

import { appInsights } from '../../../auth/appInsight';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

const FreedomButton = styled(Button)(
  ({
    theme,
    btncolor,
    btnborder,
    width,
    padding,
    lineheight,
    borderradius,
    btnbackground,
    gap,
    fontsize,
    height,
    xlheight,
    xlfontsize,
    fontweight,
    btnboxshadow,
    btnbackground1 = 'none',
    btnboxshadow1,
    btnhovercolor,
    bordercolordisable = '',
    backgroundcolordisable,
    btntextcolor,
  }) => ({
    background: btnbackground || 'transparent',
    boxShadow: `0px 4px 14px ${btnboxshadow}`,
    border: btnborder || `2px solid  ${btncolor}`,
    borderRadius: borderradius || '10px',
    gap: gap,
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: fontweight || '500',
    fontSize: fontsize || '16px',
    lineHeight: lineheight || '15px',
    color: btntextcolor || theme.palette.text.primary,
    textTransform: 'capitalize',
    width: width || '100%',
    height: height || '56px',
    padding: padding || '2px 6px',
    '&:hover': {
      background: btnbackground1 || theme.palette.hoverColor.textFieldHover,
      border: `2px solid  ${theme.palette.border.border}`
    },
    '&:disabled': {
      background: backgroundcolordisable ? backgroundcolordisable : theme.palette.button.disablebtncolor,
      border: bordercolordisable ? `2px solid ${theme.palette.primary.placehorder}` : `none`
    },
    [theme.breakpoints.down('sm')]: {
      padding: '4px',
      fontSize: fontsize || '12px'
    },
    [theme.breakpoints.up('xll')]: {
      border: getDynamicBorder(1.25, btnborder || `2px solid  ${btncolor}`),
      borderRadius: getStringProduct(1.25, borderradius || '10px'),
      gap: getStringProduct(1.25, gap),
      fontSize: getStringProduct(1.25, fontsize || '16px'),
      lineHeight: getStringProduct(1.25, lineheight || '15px'),
      height: getStringProduct(1.25, height || '56px'),
      padding: getStringProduct(1.25, padding || '2px 6px')
    },
    [theme.breakpoints.up('xlll')]: {
      border: getDynamicBorder(1.66, btnborder || `2px solid  ${btncolor}`),
      borderRadius: getStringProduct(1.66, borderradius || '10px'),
      gap: getStringProduct(1.66, gap),
      fontSize: getStringProduct(1.66, fontsize || '16px'),
      lineHeight: getStringProduct(1.66, lineheight || '15px'),
      height: getStringProduct(1.66, height || '56px'),
      padding: getStringProduct(1.66, padding || '2px 6px')
    },
    [theme.breakpoints.up('xl4')]: {
      boxShadow: `0px 3px 42px ${btnboxshadow}`,
      border: getDynamicBorder(2.46, btnborder  || `2px solid ${btncolor}`),
      borderRadius: getStringProduct(2.46, borderradius) || '30px',
      gap: getStringProduct(2.46, gap),
      fontSize: getStringProduct(2.46, fontsize || '16px'),
      lineHeight: getStringProduct(2.46, lineheight || '15px'),
      width: getStringProduct(2.46, width) || '100%',
      height: getStringProduct(2.46, height || '56px'),
      padding: getStringProduct(2.46, padding || '2px 6px')
    }
  })
);
const FreedomButton2 = (props) => {
  const { children, ...rest } = props;
  try {
    return (
      <FreedomButton disableElevation={true} disableRipple={true} disableFocusRipple={true} {...rest}>
        {children}
      </FreedomButton>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomButton2;
